// For legacy block support
import 'slick-carousel';
// import initFeatherlight from 'featherlight'
// initFeatherlight();
import './legacy-blocks';

import './blog';
import './navigation';
import './responsive-spacers';
import './search';
import './fslightbox-3.6.0';
import htmx from 'htmx.org';
import Splide from '@splidejs/splide';

htmx.config.globalViewTransitions = true;

document.addEventListener('DOMContentLoaded', function () {
    // Do stuff
});


// Text Buttons
document.addEventListener('DOMContentLoaded', function() {
    // Find all anchor tags that have a class starting with 'btn-text-'
    const textButtons = document.querySelectorAll('a[class*="btn-text-"]');
    
    textButtons.forEach(button => {
        // Get the text content
        const text = button.childNodes[0].textContent.trim();
        
        // Only wrap if it's not already wrapped
        if (button.querySelector('span') === null) {
            // Clear the text content
            button.childNodes[0].textContent = '';
            // Create and insert the span
            const span = document.createElement('span');
            span.textContent = text;
            button.insertBefore(span, button.firstChild);
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    // Select only elements within the specific block and headings div
    const elements = document.querySelectorAll('.wp-block-icb-icb005-highlight-cta .headings h2, .wp-block-icb-icb008-hero h1');
    
    elements.forEach(element => {
        // Get the current HTML content
        let content = element.innerHTML;
        
        // Replace periods with wrapped periods, but only if they're not already wrapped
        // and not part of an HTML tag or class name
        content = content.replace(/(?<!<[^>]*)\./g, '<span class="dot">.</span>');
        
        // Update the element's content
        element.innerHTML = content;
    });
});

// Announcement Bar
document.addEventListener('DOMContentLoaded', function() {
    const toggle = document.querySelector('#announcement-bar .toggle');
    
    if (toggle) {
        toggle.addEventListener('click', function() {
            const announcementBar = document.querySelector('#announcement-bar');
            if (announcementBar) {
                announcementBar.remove();
                sessionStorage.setItem('announcement-hidden', 'true');
            }
        });
    }

    if (sessionStorage.getItem('announcement-hidden') === 'true') {
        const announcementBar = document.querySelector('#announcement-bar');
        if (announcementBar) {
            announcementBar.remove();
        }
    }
});

// // Announcement Bar
// document.addEventListener('DOMContentLoaded', function() {
//     const toggle = document.querySelector('#announcement-bar .toggle');
    
//     if (toggle) {
//         toggle.addEventListener('click', function() {
//             const announcementBar = document.querySelector('#announcement-bar');
//             if (announcementBar) {
//                 announcementBar.classList.add('hidden');
//                 sessionStorage.setItem('announcement-hidden', 'true');
//             }
//         });
//     }

//     if (sessionStorage.getItem('announcement-hidden') === 'true') {
//         const announcementBar = document.querySelector('#announcement-bar');
//         if (announcementBar) {
//             announcementBar.classList.add('hidden');
//         }
//     }
// });

// Announcement Bar
document.addEventListener('DOMContentLoaded', function() {
    const toggle = document.querySelector('#announcement-bar .toggle');
    const siteWrap = document.querySelector('.site-wrap');
    const announcementBar = document.querySelector('#announcement-bar');
    
    // Function to update site-wrap class based on announcement visibility
    function updateSiteWrapClass() {
        if (announcementBar && !announcementBar.classList.contains('hidden')) {
            // Add class when announcement bar is visible
            siteWrap && siteWrap.classList.add('with-announcement-bar');
        } else {
            // Remove class when announcement bar is hidden
            siteWrap && siteWrap.classList.remove('with-announcement-bar');
        }
    }

    // Function to update announcement bar height
    function updateAnnouncementHeight() {
        if (announcementBar) {
            if (!announcementBar.classList.contains('hidden')) {
                const height = announcementBar.offsetHeight;
                document.documentElement.style.setProperty('--announcement-height', `${height}px`);
            } else {
                document.documentElement.style.setProperty('--announcement-height', '0px');
            }
        }
    }
    
    // Function to hide announcement bar
    function hideAnnouncementBar() {
        if (announcementBar) {
            announcementBar.classList.add('hidden');
            sessionStorage.setItem('announcement-hidden', 'true');
            updateSiteWrapClass();
            updateAnnouncementHeight();
        }
    }
    
    // Initial setup
    if (announcementBar) {
        // Set initial height
        updateAnnouncementHeight();
        
        // Check session storage after a small delay to prevent flash
        setTimeout(() => {
            if (sessionStorage.getItem('announcement-hidden') === 'true') {
                hideAnnouncementBar();
            }
        }, 50);
        
        // Use ResizeObserver to watch for size changes
        const resizeObserver = new ResizeObserver(() => {
            updateAnnouncementHeight();
        });
        resizeObserver.observe(announcementBar);
    }
    
    if (toggle) {
        toggle.addEventListener('click', hideAnnouncementBar);
    }
});